// Keep in sync with backend core.py VISUAL_STYLES keys.
export const VISUAL_STYLES = [
  { v: "cinematic", l: "Cinematic", thumb: "/style-thumbs/cinematic.jpg" },
  { v: "photorealistic", l: "Photorealistic", thumb: "/style-thumbs/photorealistic.jpg" },
  { v: "3d_render", l: "3D render", thumb: "/style-thumbs/3d_render.jpg" },
  { v: "anime", l: "Anime", thumb: "/style-thumbs/anime.jpg" },
  { v: "minimal", l: "Minimal / flat", thumb: "/style-thumbs/minimal.jpg" },
  { v: "retro", l: "Retro", thumb: "/style-thumbs/retro.jpg" },
  { v: "documentary", l: "Documentary", thumb: "/style-thumbs/documentary.jpg" },
  { v: "dark_moody", l: "Dark & moody", thumb: "/style-thumbs/dark_moody.jpg" },
  { v: "comic", l: "Comic book", thumb: "/style-thumbs/comic.jpg" },
  { v: "comic_dark", l: "Comic book · dark", thumb: "/style-thumbs/comic_dark.jpg" },
  { v: "bold_poster", l: "Bold poster", thumb: "/style-thumbs/bold_poster.jpg" },
];

export const styleLabel = (v) => VISUAL_STYLES.find((s) => s.v === v)?.l || "Cinematic";
